var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.74023 11.3029L4.43616 6.99969L8.74023 2.69649L6.8914 0.847656L0.740234 6.99969L6.8914 13.1517L8.74023 11.3029Z","fill":"#16384E"}));
}

ChevronLeftInline.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
